module.exports = __webpack_public_path__ + "static/media/noun_Move_2451320.75b40bdd.svg";